import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import styles from "./Header.scss";
import { ReactComponent as Hamburger } from "../icons/Hamburger.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";
import { AppLogo } from "../misc/AppLogo";
import { ThemeToggle } from "./ThemeToggle";

export function MobileNav({
  enableSpoke,
  editorName,
  showDocsLink,
  docsUrl,
  showSourceLink,
  showCommunityLink,
  communityUrl,
  isAdmin
}) {
  const [navOpen, setNav] = useState(false);
  const toggleNav = () => {
    setNav(!navOpen);
  };

  return (
    <div className={styles.navContainer}>
      <div className={styles.mobileNavWrapper}>
        <a href="/" className={styles.mobileHomeLink}>
          <AppLogo />
        </a>
        <div className={styles.mobileActions}>
          <ThemeToggle compact />
          <button
            type="button"
            className={styles.menuButton}
            aria-expanded={navOpen}
            aria-controls="mobile-navigation"
            onClick={toggleNav}
          >
            <Hamburger />
            <span className={styles.screenReaderOnly}>
              {navOpen ? (
                <FormattedMessage id="header.close-menu" defaultMessage="Close menu" />
              ) : (
                <FormattedMessage id="header.open-menu" defaultMessage="Open menu" />
              )}
            </span>
          </button>
        </div>
        <div id="mobile-navigation" className={`${styles.mobileMenu} ${navOpen ? styles.mobileMenuOpen : ""}`}>
          <nav role="navigation">
            <ul>
              {enableSpoke && (
                <li>
                  <a href="/spoke">{editorName}</a>
                </li>
              )}
              {showDocsLink && (
                <li>
                  <a href={docsUrl}>
                    <FormattedMessage id="header.docs" defaultMessage="Guides" />
                  </a>
                </li>
              )}
              {showSourceLink && (
                <li>
                  <a href="https://github.com/Hubs-Foundation/hubs">
                    <FormattedMessage id="header.source" defaultMessage="Developers" />
                  </a>
                </li>
              )}
              {showCommunityLink && (
                <li>
                  <a href={communityUrl}>
                    <FormattedMessage id="header.community" defaultMessage="Community" />
                  </a>
                </li>
              )}
              {isAdmin && (
                <li>
                  <a href="/admin" rel="noreferrer noopener">
                    <i>
                      <FontAwesomeIcon icon={faCog} />
                    </i>
                    <FormattedMessage id="header.admin" defaultMessage="Admin" />
                  </a>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

MobileNav.propTypes = {
  enableSpoke: PropTypes.bool,
  editorName: PropTypes.string,
  showDocsLink: PropTypes.bool,
  docsUrl: PropTypes.string,
  showSourceLink: PropTypes.bool,
  showCommunityLink: PropTypes.bool,
  communityUrl: PropTypes.string,
  isAdmin: PropTypes.bool
};
